import React from 'react';
import { Button } from 'antd';

const CustomButton = ({ text, onClick, backgroundColor = 'green', borderColor = 'green', ...props }) => {
  return (
    <Button
      type="primary"
      htmlType="submit"
      style={{
        backgroundColor: backgroundColor,
        borderColor: borderColor,
        color : 'black'
      }}
      onClick={onClick}
      {...props} // Allow additional props to be passed to the Button
    >
      {text}
    </Button>
  );
};

export default CustomButton;
